<template>
  <div
    class="
      layout/height:cap
      layout/width:100%
      "
    >
    <fade-transition>
      <paginated-list-controls
        v-if="showPaginationControls"
        :show-more-items-button-html="showMoreItemsButtonHTML"
        :current-page="currentPage"
        @fetch-paginated-items="handleShowMoreItemsClick"
      />
      <spinner v-if="showLoadingControls" />
      <p
        v-if="showMessage"
        ref="message"
        class="
          $color/gray:ccc
          $typography/size:large
          typography
        "
        v-html="noMoreItemsMessage"
      />
    </fade-transition>
  </div>
</template>

<script>
import PaginationList from './paginated-list-container.vue';

export default {
  name: 'paginated-list-container--list-heading',
  extends: PaginationList,
  props: {
    noMoreItemsMessage: { type: String, default: '' },
  },
  computed: {
    /**
     * @override
     */
    showMessage: function() {
      return !(this.showPaginationControls || this.handlingShowMoreItems) && this.noMoreItemsMessage;
    },
    /**
     * @override
     */
    searchParams: function() {
      const parameters = window.location.search.replace("?", "&");
      return new URLSearchParams(`page=${this.currentPage}${parameters}`);
    },
  },
  methods: {
    lastSubItem: function(lastItem) {
      return lastItem.querySelector("li:last-child");
    },
    /**
     * @override
     */
    handleShowMoreItemsClick: async function() {
      this.currentPage++;
      this.handlingShowMoreItems = true;

      const lastItem = this.lastItem();
      const lastSubItem = this.lastSubItem(lastItem);

      if (this.fetchPaginatedListSetupFunc)
        this.fetchPaginatedListSetupFunc();
      await this.fetchPaginatedListFunc(this.searchParams)
        .then(res => this.appendPaginatedItems(res))
        .then(() => this.reconcilePaginatedItems(lastItem))
        .then(() => this.showPaginatedItems())
        .then(() => this.handlingShowMoreItems = false)
        .then(() => {
          if (lastSubItem.nextElementSibling !== null) {
            this.focusOnFirstPaginatedItem(lastSubItem);
          } else {
            this.focusOnFirstPaginatedItem(lastItem);
          }
        })
        .then(() => this.fetchPaginatedListCompletedFunc ? this.fetchPaginatedListCompletedFunc() : null)
        .catch(error => {
          this.handlingShowMoreItems = false;
          console.error("handleShowMoreItemsClick failed with error: ", error);
        });
    },
    reconcilePaginatedItems: function(lastItem) {
      if (lastItem.querySelector("h2") == null ){
        return;
      }
      const lastItemHeading = lastItem.querySelector("h2").textContent;

      // Determine if there is a "double"
      const xpath = "//h2[contains(.,'" + lastItemHeading + "')]";
      const matchingElements = document.evaluate(xpath, document.body, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
      if (matchingElements.snapshotLength > 1) {
        const lastItemUlInsertion = lastItem.querySelector("ul");
        const newItem = lastItem.nextElementSibling;
        const listItems = newItem.querySelectorAll("li");

        // Append "double heading" list items to the first ul.
        const frag = document.createDocumentFragment();
        for (let li of listItems) {
          frag.appendChild(li);
        }
        lastItemUlInsertion.appendChild(frag);

        // Remove the "double heading" now that its empty.
        newItem.parentNode.removeChild(newItem);
      }
    },
  }
};
</script>
